import { runInSandbox } from '@epicuro-next/addons/sandbox';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';

export function multipleItemsMapper(items: unknown[], mapFunction: string) {
  const mapper = `(function () {
    const items = ${JSON.stringify(items)};
    ${mapFunction}
    return items.map(mapFunction);
  })()`;

  return runInSandbox(of(mapper)).pipe(take(1));
}
